<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      style="color: white"
      :title="`${$t('langcfg.txtResultPreview')}`"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      top="12vh"
      z-index="1000"
    >
      <!-- <img style="width: 90%; height: 90%; margin-left: 5%" :src="`file://${src}`" alt="" /> -->
      <ImageBoxPupil
        v-if="pupilCorneaState !== 'pupilcorneadia_dynamic'"
        :src="src"
        :width="920"
        :height="920 * (768 / 1024)"
        :focus="true"
        colorHex="#00ff00"
        :info="getInfo()"
        :proc="getProc()"
        :eyetype="eyeType"
        currentUnit="mm"
        :currentPhoto="''"
        curPage="pupilcorneadia"
        :edges="edges"
        graphMode="Select"
      />

      <PupilCorneaVideo
        v-else
        :width="920"
        :height="920 * (768 / 1024)"
        :src="src"
        :record="record"
        :currentEye="eyeType"
        :realTotalTime="-1"
        :pupilDiameterData="puilCorneaData.resultPupilDiameter"
        :pupilCenterX="puilCorneaData.resultPupilCenterX"
        :pupilCenterY="puilCorneaData.resultPupilCenterY"
        :ringCenterX="puilCorneaData.ringCenterX"
        :ringCenterY="puilCorneaData.ringCenterY"
      />

      <div class="btn-area">
        <el-button class="btn-oprator border-normal" @click="hideDialog('cancel')"
          ><span>{{ $t("langcfg.txtCancel") }}</span></el-button
        >
        <el-button
          v-if="!isPupilOKBtnVisible && isNewInfrared"
          class="btn-oprator border-normal"
          @click="hideDialog('OK')"
          ><span>{{ $t("langcfg.txtNext") }}</span></el-button
        >
        <el-button class="btn-oprator border-normal" @click="hideDialog('end')"
          ><span>{{ $t("langcfg.txtEndCapture") }}</span></el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ImageBoxPupil from "../../common/components/ImageBoxPupil.vue";
import PupilCorneaVideo from "../../topography/components/PupilConeaVideo.vue";

export default {
  name: "PupilCorneaPreview",
  data() {
    return {
      isNewInfrared: window.isNewInfrared(),
      visible: false,
      src: "",
      edges: {},
      puilCorneaData: {
        resultPupilDiameter: [],
        resultPupilCenterX: [],
        resultPupilCenterY: [],
        ringCenterX: [],
        ringCenterY: []
      }
    };
  },
  props: {
    isVisible: false,
    isPupilOKBtnVisible: true,
    record: {},
    eyeType: "OD",
    pupilCorneaState: "pupilcorneadia_dark"
  },
  components: {
    ImageBoxPupil,
    PupilCorneaVideo
  },
  mounted() {
    if (this.pupilCorneaState !== "pupilcorneadia_dynamic") {
      this.edges = this.getPreviewEdges(this.record);
      this.src = this.getPreviewSrc(this.record);
    } else {
      this.puilCorneaData = this.getVideoData(this.record);
      this.src = this.getPreviewSrc(this.record);
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler() {
        this.visible = this.isVisible;
      }
    }
  },
  methods: {
    hideDialog(value) {
      this.$emit("hide-dialog", value);
    },
    getInfo: function () {},
    getProc() {},
    getPreviewEdges(record) {
      if (
        record.content &&
        record.content[`data${this.eyeType}`] &&
        record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
      ) {
        const data = record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`];
        return {
          corneadia: {
            r: 0,
            x: 0,
            y: 0
          },
          pupildia: {
            r: data.pupildia.edge.r,
            x: data.pupildia.edge.x,
            y: data.pupildia.edge.y,
            rx: data.pupildia.edge.rx,
            ry: data.pupildia.edge.ry
          }
        };
      } else {
        return {
          corneadia: {
            r: 0,
            x: 0,
            y: 0
          },
          pupildia: {
            r: -1000,
            x: -1000,
            y: -1000,
            rx: -1000,
            ry: -1000
          }
        };
      }
    },
    getPreviewSrc(record) {
      if (
        record.content &&
        record.content[`data${this.eyeType}`] &&
        record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
      ) {
        const data = record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`];
        const { serverip, serverport, sslport, serverssl } = window.server || {};
        const protocol = serverssl === 1 ? "https:" : "http:";
        const port = serverssl === 1 ? sslport : serverport;
        const src = `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`;
        return src;
      } else {
        return "";
      }
    },
    getVideoData(record) {
      if (
        record.content &&
        record.content[`data${this.eyeType}`] &&
        record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`]
      ) {
        const data = record.content[`data${this.eyeType}`][`${this.pupilCorneaState}`];
        // this.puilCorneaData = {
        //   resultPupilDiameter: data.pupilArray.resultPupilDiameter,
        //   resultPupilCenterX: data.pupilArray.resultPupilCenterX,
        //   resultPupilCenterY: data.pupilArray.resultPupilCenterY,
        //   ringCenterX: data.pupilArray.ringCenterX,
        //   ringCenterY: data.pupilArray.ringCenterY,
        //   media: `${protocol}//${serverip}:${port}/media/${data.photos[0].filename}?access_token=${window.token}`
        // };

        return {
          resultPupilDiameter: data.pupilArray.resultPupilDiameter,
          resultPupilCenterX: data.pupilArray.resultPupilCenterX,
          resultPupilCenterY: data.pupilArray.resultPupilCenterY,
          ringCenterX: data.pupilArray.ringCenterX,
          ringCenterY: data.pupilArray.ringCenterY
        };
      } else {
        return {
          resultPupilDiameter: [],
          resultPupilCenterX: [],
          resultPupilCenterY: [],
          ringCenterX: [],
          ringCenterY: []
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.photo-preview {
  position: absolute;
  background: red;
  z-index: 50;
}
.el-button {
  min-width: 200px;
  margin-left: 5%;
  font-size: @header-fs;
  color: white;
  i {
    font-size: @header-fs+30px;
  }
}
.btn-oprator {
  height: @header-fs+30px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  span {
    color: @btn-hover-color;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
.border-normal :hover {
  span {
    color: @btn-hover-color;
  }
}
.btn-area {
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

/deep/.el-dialog {
  margin-left: 15vw;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/PupilCorneaPreview.vue